module.exports = __webpack_public_path__ + "static/media/about_me.1a6d9159.jpg";